import { Checkbox, FormControl, FormControlLabel, InputLabel, makeStyles, MenuItem, Paper, Select, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         // formControl: {
//         //     margin: theme.spacing(1),
//         //     position: 'relative',
//         //     top: '0.55rem',
//         //     // minWidth: 320,
//         // },
//         // textField: {
//         //     marginLeft: theme.spacing(1),
//         //     marginRight: theme.spacing(1),
//         //     width: "18rem",
//         // },
//         // select: {
//         //     width: "10rem",
//         // },
//         // bottomControlLabel: {
//         //     verticalAlign: 'bottom',
//         //     marginLeft: theme.spacing(1),
//         // },
//         // boldLabel: {
//         //     marginTop: "1rem",
//         //     fontWeight: 900
//         // }
//     }),
// );

export default function PersonaFisicaProfessionista(props: SchedaBudgetInputProps) {

    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeImposteContributi";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;

        if (name === "F77_senzacassaal24" && checked === true) {
            if (state.imposteContributi.F78_senzacassaal2598 === true)
                state.imposteContributi.F78_senzacassaal2598 = false;

            if (state.imposteContributi.F80_con_cassa_autonoma === true) {
                state.imposteContributi.F80_con_cassa_autonoma = false;
                state.imposteContributi.G80_con_cassa_autonoma = 0;
            }
        }
        else if (name === "F78_senzacassaal2598" && checked === true) {
            if (state.imposteContributi.F77_senzacassaal24 === true)
                state.imposteContributi.F77_senzacassaal24 = false;

            if (state.imposteContributi.F80_con_cassa_autonoma === true) {
                state.imposteContributi.F80_con_cassa_autonoma = false;
                state.imposteContributi.G80_con_cassa_autonoma = 0;
            }
        }
        else if (name === "F80_con_cassa_autonoma" && checked === true) {
            if (state.imposteContributi.F77_senzacassaal24 === true)
                state.imposteContributi.F77_senzacassaal24 = false;
            if (state.imposteContributi.F78_senzacassaal2598 === true)
                state.imposteContributi.F78_senzacassaal2598 = false;
        }

        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, name, checked, action, true);
    };

    return (
        <Paper className={gClasses.fullWidthPaper}>
            <div>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.F77_senzacassaal24}
                            name='F77_senzacassaal24'
                            id='F77_senzacassaal24'
                            value={state.imposteContributi.F77_senzacassaal24}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Senza cassa al 24%"
                />
                <FormControlLabel className={gClasses.bottomControlLabel} 
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.F78_senzacassaal2598}
                            name='F78_senzacassaal2598'
                            id='F78_senzacassaal2598'
                            value={state.imposteContributi.F78_senzacassaal2598}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Senza cassa al 26.23%"
                />
            </div>
            <div>
                <FormControlLabel className={gClasses.bottomControlLabel} 
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.F80_con_cassa_autonoma}
                            name='F80_con_cassa_autonoma'
                            id='F80_con_cassa_autonoma'
                            value={state.imposteContributi.F80_con_cassa_autonoma}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Con Cassa Autonoma"
                />
                <NumberField
                    name="G80_con_cassa_autonoma"
                    label=""
                    value={state.imposteContributi.G80_con_cassa_autonoma}
                    className={gClasses.textField}
                    onChange={handleChange}
                />
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Carichi familiari</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel} 
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H78_coniuge}
                            name='H78_coniuge'
                            id='H78_coniuge'
                            value={state.imposteContributi.H78_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge"
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="I77_nfigli">N. Figli</InputLabel>
                    <Select
                        className={gClasses.selectIForf}
                        value={state.imposteContributi.I78_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I78_nfigli', id: 'I78_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="J77_pfigli">% Figli</InputLabel>
                    <Select
                        className={gClasses.selectIForf}
                        value={state.imposteContributi.J78_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J78_pfigli', id: 'J78_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </div>
        </Paper>
    )
}